var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"app-button",attrs:{"title":_vm.title || '',"disabled":_vm.disabled},on:{"click":function($event){_vm.$emit('click')}}},[_c('span',[_vm._t("default",[_vm._v("Button")],{tag:"span"})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cadcee6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","ParallaxImage":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppButton.vue
// module id = null
// module chunks = 